import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/60">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="font-heading font-bold text-foreground-950 mb-4">
                <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">麻花影院</Link>
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                聚合最新电影高清大片资源，热门动作片、科幻片、喜剧电影免费在线观看，更新不断。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-bold text-foreground-950 mb-4">
                <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">电影分类</Link>
              </h4>
              <ul className="space-y-2">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-bold text-foreground-950 mb-4">
                <a href="#hot" className="hover:text-primary-400 transition-colors cursor-pointer">热门推荐</a>
              </h4>
              <ul className="space-y-2">
                <li><Link to="/category/dongzuo" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">动作大片</Link></li>
                <li><Link to="/category/kehuan" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">科幻巨制</Link></li>
                <li><Link to="/category/xiju" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">爆笑喜剧</Link></li>
                <li><Link to="/category/donghua" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精品动画</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-bold text-foreground-950 mb-4">
                <Link to="/about" className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
              </h4>
              <ul className="space-y-2">
                <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">品牌介绍</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</Link></li>
                <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">用户协议</a></li>
                <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a></li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 麻花影院 版权所有 | 本站内容仅供学习交流使用
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}